import { render, staticRenderFns } from "./australiaReview.vue?vue&type=template&id=03c48462&"
import script from "./australiaReview.vue?vue&type=script&lang=js&"
export * from "./australiaReview.vue?vue&type=script&lang=js&"
import style0 from "./australiaReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports